import script from "./LimitesCreditoExtrato.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitesCreditoExtrato.vue?vue&type=script&setup=true&lang=js"

import "./LimitesCreditoExtrato.vue?vue&type=style&index=0&id=ddd42030&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd42030"]])

export default __exports__